__turbopack_context__.v({
  "bounce": "StatCircleReveal-module__GeYCKq__bounce",
  "root": "StatCircleReveal-module__GeYCKq__root",
});
